import { render, staticRenderFns } from "./NotificationsExternal.vue?vue&type=template&id=19312d02&"
import script from "./NotificationsExternal.vue?vue&type=script&lang=js&"
export * from "./NotificationsExternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports